<template>
  <div class="make-bid-document-page">
    <div class="page-shell">
      <aside class="left-sidebar">
        <div class="sidebar-header">
          <div>
            <h2 class="sidebar-title">投标文件制作台</h2>
          </div>
        </div>
        <div class="project-summary-card">
          <div class="ca-status-header">
            <div>
              <h3 class="ca-status-title">CA 登录管理</h3>
            </div>
            <el-tag :type="caLoggedIn ? 'success' : 'info'" size="mini">
              {{ caLoggedIn ? '已登录' : '未登录' }}
            </el-tag>
          </div>
          <div class="ca-status-row">
            <span>当前用户</span>
            <strong>{{ currentCaUserName || '未识别' }}</strong>
          </div>
          <el-select v-model="caForm.certId" class="ca-user-select" size="small" filterable clearable
            placeholder="请选择 CA 用户" :loading="isLoadingCert" @change="handleCAUserChange">
            <el-option v-for="item in certList" :key="item.certid" :label="item.name || item.certid"
              :value="item.certid" />
          </el-select>
          <div class="ca-action-group">
            <el-button size="small" type="primary" :loading="caLoading" @click="handleCALogin">CA 登录</el-button>
          </div>
          <div class="ca-action-group">
            <el-button size="small" type="warning" :loading="caLogoutLoading" @click="handleCALogout">退出 CA</el-button>
            <el-button size="small" type="success" :loading="caSwitchLoading" @click="handleCASwitch">切换 CA</el-button>
          </div>
          <div class="ca-action-group">
            <el-button size="small" type="primary" @click="registerCA">CA 注册</el-button>
          </div>
        </div>
        <el-menu :default-active="activeMenu" class="document-menu" :unique-opened="true" @select="handleMenuSelect">
          <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-document-copy"></i>
              <span>招标文件</span>
            </template>
            <el-menu-item index="1-1">正文概览</el-menu-item>
            <el-menu-item index="1-2">附件资料</el-menu-item>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">
              <i class="el-icon-s-order"></i>
              <span>开标一览表</span>
            </template>
            <el-menu-item index="2-1">报价信息</el-menu-item>
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">
              <i class="el-icon-folder-opened"></i>
              <span>投标附件</span>
            </template>
            <el-menu-item index="3-1">附件</el-menu-item>
          </el-submenu>
          <el-submenu index="4">
            <template slot="title">
              <i class="el-icon-notebook-2"></i>
              <span>投标正文</span>
            </template>
            <el-menu-item index="4-1">正文</el-menu-item>
          </el-submenu>
        </el-menu>
        <div class="encrypt-btn" @click="handleEncryptClick">
          <i class="el-icon-lock"></i>
          <span>加密上传</span>
        </div>
      </aside>
      <main class="right-content">
        <section class="content-panel">
          <div class="single-template-card">
            <div class="card-header-row">
              <div>
                <div class="menu-display-chip">当前菜单</div>
                <h2 class="menu-display-title">{{ currentPanel.title }}</h2>
                <p class="menu-display-desc">{{ currentPanel.description }}</p>
              </div>
            </div>
            <div v-if="activeMenu === '1-1'" class="pdf-preview-panel">
              <div v-if="invitationMainUrl" class="pdf-viewer-container">
                <div class="pdf-viewer-toolbar">
                  <el-button type="primary" size="small" icon="el-icon-download" @click="handleDownloadPdf">
                    下载正文
                  </el-button>
                </div>
                <PdfViewer :pdf-url="invitationMainUrl" :show-toolbar="false" :initial-scale="1" />
              </div>
              <div v-else class="template-placeholder">
                <div class="placeholder-icon">
                  <i class="el-icon-document"></i>
                </div>
                <div class="placeholder-text">
                  <strong>暂无正文文件</strong>
                  <span>当前标段暂未获取到投标文件正文 PDF。</span>
                </div>
              </div>
            </div>
            <div v-else-if="activeMenu === '1-2'" class="attachment-panel">
              <el-table :data="formattedInvitationAttList" class="attachment-table">
                <el-table-column prop="fileName" label="文件名称"></el-table-column>
                <el-table-column prop="fileExtension" label="格式"></el-table-column>
                <el-table-column prop="fileSizeText" label="大小"></el-table-column>
                <el-table-column label="下载地址">
                  <template slot-scope="scope">
                    <a :href="scope.row.fileUrl" target="_blank" class="file-link">下载文件</a>
                  </template>
                </el-table-column>
              </el-table>
              <div v-if="!formattedInvitationAttList.length" class="template-placeholder">
                <div class="placeholder-icon">
                  <i class="el-icon-folder-opened"></i>
                </div>
                <div class="placeholder-text">
                  <strong>暂无附件</strong>
                  <span>当前标段暂未获取到投标文件正文附件列表。</span>
                </div>
              </div>
            </div>

            <div v-else-if="activeMenu === '2-1'" class="content-panel">
              <div class="panel-header-actions">
                <h3 class="content-title">开标一览表</h3>
                <el-button type="primary" size="small" @click="handleOpeningSummarySave">保存</el-button>
              </div>
              <div class="content-body">
                <el-table :data="openingSummaryList" style="width: 100%">
                  <el-table-column prop="itemKey" label="序号" align="center" width="60" />
                  <el-table-column prop="itemName" label="附件名称" />
                  <el-table-column prop="itemValueType" label="数值类型">
                    <template slot-scope="scope">
                      <span v-if="scope.row.itemType == 0">任意文本</span>
                      <span v-if="scope.row.itemType == 1">纯数字</span>
                      <span v-if="scope.row.itemType == 6">工期</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="内容">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.itemValue"
                        :placeholder="isCapitalRequired(scope.row.itemName) ? '请输入中文大写' : '请输入内容'"
                        @input="handleItemValueInput(scope.row, scope.$index)" />
                    </template>
                  </el-table-column>
                  <el-table-column prop="itemUnit" label="单位">
                    <template slot-scope="scope">
                      <span v-if="scope.row.itemUnit == 0">元</span>
                      <span v-if="scope.row.itemUnit == 1">万元</span>
                      <span v-if="scope.row.itemUnit == 2">%</span>
                      <span v-if="scope.row.itemUnit == null">-</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="itemType" label="类型">
                    <template slot-scope="scope">
                      <span v-if="scope.row.itemType == 1">总价</span>
                      <span v-if="scope.row.itemType == 2">费率</span>
                      <span v-if="scope.row.itemType == 3">单价</span>
                      <span v-if="scope.row.itemType == 9">其他</span>
                      <span v-if="scope.row.itemType == 0">文本内容</span>
                      <span v-if="scope.row.itemType == 6">工期</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="remark" label="备注" min-width="120" />
                </el-table>
              </div>
            </div>
            <!-- 投标附件 3-1 -->
            <div v-else-if="activeMenu === '3-1'" class="bid-att-panel">
              <div class="upload-section">
                <div class="panel-header-actions">
                  <h4 class="section-title">上传投标附件</h4>
                  <el-button type="primary" size="small" @click="handleBidAttSave">保存</el-button>
                </div>
                <el-upload ref="attUploader" class="att-uploader hide-file-list" action="#" :auto-upload="false"
                  :on-change="handleAttFileChange" :file-list="pendingAttFiles" multiple
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.png">
                  <el-button type="primary" icon="el-icon-upload2">选择附件</el-button>
                  <div slot="tip" class="el-upload__tip">支持 PDF、Word、Excel、图片等格式，可多选</div>
                </el-upload>
              </div>
              <!-- 待上传附件列表 -->
              <div v-if="pendingAttFiles.length" class="pending-files">
                <h4 class="section-title">待上传附件 ({{ pendingAttFiles.length }})</h4>
                <el-table :data="pendingAttFiles" class="pending-att-table">
                  <el-table-column label="文件名称" min-width="200">
                    <template slot-scope="scope">
                      <div class="file-name-cell">
                        <i :class="getFileIcon(scope.row.name)"></i>
                        <span>{{ scope.row.name }}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="大小" width="100">
                    <template slot-scope="scope">
                      {{ formatFileSize(scope.row.size) }}
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                      <el-button type="text" @click="previewPendingFile(scope.row)">预览</el-button>
                      <el-button type="text" class="danger-text" @click="removePendingAtt(scope.$index)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div v-if="bidAttList.length" class="existing-files">
                <h4 class="section-title">已上传附件</h4>
                <el-table :data="bidAttList" class="bid-att-table">
                  <el-table-column prop="fileName" label="文件名称"></el-table-column>
                  <el-table-column prop="fileSize" label="大小(K)"></el-table-column>
                  <el-table-column prop="fileExtension" label="格式"></el-table-column>
                  <el-table-column label="操作" width="120">
                    <template slot-scope="scope">
                      <el-button type="text" size="small" @click="downloadAndDecryptAtt(scope.row)">下载</el-button>
                      <el-button type="text" size="small" @click="deleteAndDecryptAtt(scope.row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!-- 投标正文 4-1 -->
            <div v-else-if="activeMenu === '4-1'" class="bid-main-panel">
              <!-- 有签章/待上传文件/服务器正文时直接展示 PDF -->
              <div v-if="signedMainBase64 || pendingMainFile || bidMainUrl" class="main-preview-section">
                <div class="preview-header">
                  <h4 class="section-title">
                    <template v-if="signedMainBase64">
                      <el-tag type="success" size="mini" style="margin-right: 8px;">已签章</el-tag>投标正文
                    </template>
                    <template v-else-if="pendingMainFile">
                      <el-tag type="primary" size="mini" style="margin-right: 8px;">待上传</el-tag>投标正文
                    </template>
                    <template v-else-if="bidMainUrl">
                      <el-tag type="info" size="mini" style="margin-right: 8px;">已保存</el-tag>投标正文
                    </template>
                    <template v-else>待上传正文</template>
                  </h4>
                  <div class="preview-actions">
                    <el-upload ref="mainUploader" class="reupload-uploader hide-file-list" action="#"
                      :auto-upload="false" :on-change="handleMainReupload" :limit="1" accept=".pdf"
                      :show-file-list="false">
                      <el-button type="primary" size="small" icon="el-icon-refresh">重新上传</el-button>
                    </el-upload>
                    <el-button type="primary" size="small" icon="el-icon-check"
                      @click="handleBidMainSave">保存</el-button>
                    <el-button type="success" size="small" icon="el-icon-download"
                      @click="downloadBidMain">正文下载</el-button>
                    <el-button type="warning" size="small" icon="el-icon-edit" @click="handleGoSign">签章</el-button>
                  </div>
                </div>
                <div class="main-pdf-viewer">
                  <div class="pdf-chapters" v-if="mainPdfDisplayUrl">
                    <div class="chapter-title">目录</div>
                    <el-tree class="catalogue-tree" :data="catalogueList" :props="catalogueProps" node-key="strId"
                      default-expand-all highlight-current @node-click="handleCatalogueClick">
                      <span slot-scope="{ data }" class="custom-tree-node">
                        <span class="catalogue-node-title" :title="data.catalogueName">{{ data.catalogueName }}</span>
                        <el-tag v-if="data.pageNum" class="catalogue-node-tag" size="mini" type="info">第{{ data.pageNum
                        }}页</el-tag>
                        <el-button type="text" size="mini" class="catalogue-node-action"
                          @click.stop="bindCataloguePage(data)">
                          {{ data.pageNum ? '修改' : '关联' }}
                        </el-button>
                      </span>
                    </el-tree>
                  </div>
                  <div class="pdf-viewer-panel">
                    <div v-if="mainPdfDisplayUrl" class="pdf-viewer-scroll">
                      <PdfViewer ref="bidPdfViewer" :pdf-url="mainPdfDisplayUrl" :show-toolbar="true" :initial-scale="1"
                        @pdf-loaded="onBidPdfLoaded" @page-changed="onBidPdfPageChanged"
                        @pdf-error="handleBidPdfError" />
                    </div>
                    <div v-else class="no-preview">
                      <i class="el-icon-document"></i>
                      <p>无法预览该文件</p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 空状态：首次上传 -->
              <div v-else class="upload-empty-state">
                <div class="upload-section">
                  <h4 class="section-title">上传投标正文</h4>
                  <el-upload ref="mainUploader" class="main-uploader hide-file-list" action="#" :auto-upload="false"
                    :on-change="handleMainFileChange" :file-list="pendingMainFile ? [pendingMainFile] : []" :limit="1"
                    accept=".pdf">
                    <el-button type="primary" icon="el-icon-upload2">选择PDF文件</el-button>
                    <div slot="tip" class="el-upload__tip">仅支持 PDF 格式，文件大小建议不超过 50MB</div>
                  </el-upload>
                </div>
              </div>
            </div>
            <div v-else class="template-placeholder">
              <div class="placeholder-icon">
                <i class="el-icon-document"></i>
              </div>
              <div class="placeholder-text">
                <strong>{{ currentPanel.title }}</strong>
                <span>这里保留为通用模板展示区域，仅显示当前选中的菜单名称。</span>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>

    <!-- 文件预览弹窗 -->
    <el-dialog :visible.sync="previewVisible" :title="previewTitle" width="80%" top="5vh" append-to-body
      @close="closePreview">
      <div class="preview-container">
        <!-- PDF 预览 -->
        <iframe v-if="previewUrl && previewTitle.endsWith('.pdf')" :src="previewUrl" class="preview-frame"
          frameborder="0"></iframe>
        <!-- 图片预览 -->
        <img v-else-if="previewUrl && isImageFile(previewTitle)" :src="previewUrl" class="preview-image" />
        <!-- 其他文件提示 -->
        <div v-else class="preview-not-supported">
          <i class="el-icon-warning-outline"></i>
          <p>该文件类型不支持在线预览，请下载后查看</p>
          <a :href="previewUrl" :download="previewTitle" class="download-link">
            <el-button type="primary">下载文件</el-button>
          </a>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getInvitationMain, getInvitationAttList, getOpeningSummaryList, addOpeningSummary, getBidKeyInfo, uploadBidAtt, getBidAttList, deleteBidAtt, uploadBidSign, getBidMain, getInvitationCatalogue, getBidCatalogue, finishBidMake } from '@/api/make/api'
import PdfViewer from '@/components/common/PdfViewer.vue'
import { XTXASynObject } from '@/api/ca/XTXASynObject'
import { useStore } from '@/api/ca/store/index'
import { makeBidDocumentFileMethods } from '@/utils/makeBidDocumentFileUtils'
import { getFileDownloadList } from '@/api/base/api'

export default {
  components: { PdfViewer },
  name: 'MakeBidDocument',
  data() {
    return {
      bidKeyInfo: null,
      activeMenu: '1-1',
      projectInfo: {
        sectionCode: this.$route.query.sectionCode,
      },
      invitationMainUrl: '',
      invitationAttList: [],
      openingSummaryList: [],
      // 投标文件相关数据
      bidAttList: [], // 已上传的投标附件列表
      bidMainUrl: '', // 已上传的投标正文URL
      catalogueList: [],
      catalogueProps: {
        children: 'children',
        label: 'catalogueName'
      },
      currentBidPage: 1,
      currentMainPdfLoadedUrl: '',
      openingSummarySavedSnapshot: '',
      pendingAttFiles: [], // 待上传的附件文件（本地缓存）
      pendingMainFile: null, // 待上传的正文文件（本地缓存）
      previewMainUrl: '', // 待上传正文的预览URL
      signedMainBase64: '', // 签章后的正文base64
      signedMainBlobUrl: '', // 签章后的正文Blob URL（用于iframe展示）
      // 预览相关
      previewVisible: false,
      previewUrl: '',
      previewTitle: '',
      // 投标文件签章相关数据
      bidSignList: [], // 已上传的签章文件列表
      pendingSignFiles: [], // 待上传的签章文件（本地缓存）
      // CA相关数据
      xtxObject: null,
      caStore: null,
      certList: [], // 证书列表
      caForm: {
        certId: '',
        passWd: '111111'
      },
      defaultCaCertId: 'MSSPDefaultContainer/msspDev000000000000000000',
      caLoading: false,
      isLoadingCert: false,
      caStatusLoading: false,
      caLogoutLoading: false,
      caSwitchLoading: false,
      caLoggedIn: false,
      currentCaUserName: '',
      // 非对称加解密表单
      asymForm: {
        cert: '', // 加密证书(Exchange)
        plain: '', // 原文
        cipher: '', // 密文
        decrypted: '', // 解密后明文
        base64Out: true
      },
      asymLoading: {
        encrypt: false,
        decrypt: false
      },
      // 对称密钥
      symKey: ''
    }
  },
  computed: {
    currentPanel() {
      const panelMap = {
        '1-1': { title: '招标文件正文概览', description: '' },
        '1-2': { title: '招标文件附件资料', description: '' },
        '2-1': { title: '开标一览表概览', description: '' },
        '3-1': { title: '投标附件整理区', description: '' },
        '4-1': { title: '投标正文', description: '' },
        '5': { title: '加密上传', description: '点击进行加密上传操作' }
      }
      return panelMap[this.activeMenu] || panelMap['1-1']
    },
    // 投标正文展示URL：签章后 > 待上传本地预览
    mainPdfDisplayUrl() {
      if (this.signedMainBlobUrl) return this.signedMainBlobUrl
      if (this.previewMainUrl) return this.previewMainUrl
      if (this.bidMainUrl) return this.bidMainUrl
      return ''
    },
    formattedInvitationAttList() {
      return this.invitationAttList.map(item => ({
        ...item,
        fileSizeText: this.formatFileSize(item.fileSize)
      }))
    }
  },
  created() {
    // 初始化CA对象
    this.xtxObject = new XTXASynObject()
    this.caStore = useStore()
  },
  mounted() {
    // 先尝试恢复签章前保存的页面状态
    this.restorePageStateAfterSign()
    this.loadInvitationMain()
    this.loadInvitationAttList()
    this.initCertList()
    this.checkSignedPdf()
    this.getBidKeyInfo()
    this.loadBidAttList()
    this.getBidMain()
    this.loadInvitationCatalogue()
  },
  methods: {
    registerCA() {
      window.open('https://online.bjca.org.cn/v2/#/index/indexNew?channelId=PT1nTjRnak13QVRN', '_blank')
    },
    ...makeBidDocumentFileMethods,
    // 解密从接口获取的secretKey
    async decryptSecretKey(encryptedKey) {
      try {
        const certId = this.getCurrentOperateCertId()
        const plainKey = await this.xtxObject.SOF_PriKeyDecrypt(certId, encryptedKey)
        return plainKey
      } catch (error) {
        console.error('解密对称密钥失败:', error)
        return null
      }
    },

    //获取密钥
    async getBidKeyInfo() {
      const res = await getBidKeyInfo(this.projectInfo.sectionCode)
      console.log('获取密钥');
      console.log(res);
      console.log('获取密钥');
      if (res.code == 200) {
        if (res.data !== null) {
          // 先保存密钥信息（包含加密后的secretKey，保存时需要）
          this.bidKeyInfo = res.data
          // 解密secretKey获取明文对称密钥
          const plainKey = await this.decryptSecretKey(res.data.secretKey)
          if (plainKey) {
            this.symKey = plainKey
          }
        } else {
          this.loadOpeningSummaryList()
        }
      }
    },
    // CA登录后自动获取密钥并解密
    async getBidKeyInfoAndDecrypt() {
      console.log('CA登录后自动获取密钥并解密');

      try {
        const res = await getBidKeyInfo(this.projectInfo.sectionCode)
        if (res.code == 200 && res.data !== null) {
          // 先保存密钥信息（包含加密后的secretKey）
          this.bidKeyInfo = res.data
          // 解密secretKey获取明文对称密钥
          const plainKey = await this.decryptSecretKey(res.data.secretKey)
          if (plainKey) {
            this.symKey = plainKey
            // 获取密钥后，加载并解密开标一览表
            await this.loadOpeningSummaryList()
          }
        } else {
          // 没有密钥，直接加载开标一览表
          await this.loadOpeningSummaryList()
        }
      } catch (error) {
        console.error('获取密钥并解密失败:', error)
        // 出错时也尝试加载开标一览表
        await this.loadOpeningSummaryList()
      }
    },
    // 加载招标文件正文
    async loadInvitationMain() {
      if (!this.projectInfo.sectionCode) {
        return
      }
      try {
        const res = await getInvitationMain(this.projectInfo.sectionCode)
        if (res.code === 200) {
          this.invitationMainUrl = res.data || ''
          return
        }
        this.$message.error(res.msg)
      } catch (error) {
        this.$message.error('获取投标文件正文失败')
      }
    },
    // 投标文件正文附件
    async loadInvitationAttList() {
      if (!this.projectInfo.sectionCode) {
        return
      }
      try {
        const res = await getInvitationAttList(this.projectInfo.sectionCode)
        if (res.code === 200) {
          this.invitationAttList = Array.isArray(res.data) ? res.data : []
          return
        }
        this.$message.error(res.msg)
      } catch (error) {
        this.$message.error('获取投标文件正文附件失败')
      }
    },
    // 获取开标一览表
    async loadOpeningSummaryList() {
      if (!this.projectInfo.sectionCode) {
        return
      }
      try {
        const res = await getOpeningSummaryList(this.projectInfo.sectionCode)
        if (res.code === 200) {
          // 如果有加密数据且已获取对称密钥，自动解密
          if (res.data.encryptStatus == 1 && res.data.encryptData && this.symKey) {
            try {
              const encryptMethod = 0x00000401
              await this.xtxObject.SOF_SetEncryptMethod(encryptMethod)
              const plainText = await this.xtxObject.SOF_SymDecryptData(this.symKey, res.data.encryptData)
              if (plainText) {
                this.openingSummaryList = JSON.parse(plainText)
                this.openingSummarySavedSnapshot = JSON.stringify(this.openingSummaryList || [])
              } else {
                this.$message.error('解密失败')
              }
            } catch (e) {
              console.error('解密失败:', e)
              this.$message.error('解密失败')
            }
          } else {
            this.openingSummaryList = Array.isArray(res.data.list) ? res.data.list : []
            this.openingSummarySavedSnapshot = JSON.stringify(this.openingSummaryList || [])
          }
          return
        }
        console.log(res);
        this.$message.error(res.msg)
      } catch (error) {
        this.$message.error('获取开标一览表失败')
      }
    },
    //新增开标一览表
    async addOpeningSummary(vl) {
      const res = await addOpeningSummary({
        sectionCode: this.projectInfo.sectionCode,
        encryptData: vl,
        secretKey: this.bidKeyInfo?.secretKey || ''
      })
      return res
    },

    /******** ----------------附件功能----------------- ********/
    formatFileSize(size) {
      if (!size || Number(size) <= 0) {
        return '--'
      }
      const numericSize = Number(size)
      if (numericSize < 1024) {
        return `${numericSize} B`
      }
      if (numericSize < 1024 * 1024) {
        return `${(numericSize / 1024).toFixed(1)} KB`
      }
      return `${(numericSize / 1024 / 1024).toFixed(2)} MB`
    },
    handleDownloadPdf() {
      if (!this.invitationMainUrl) {
        this.$message.warning('暂无投标文件正文可下载')
        return
      }
      const link = document.createElement('a')
      link.href = this.invitationMainUrl
      link.target = '_blank'
      link.download = '投标文件正文.pdf'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    // 判断是否需要中文大写
    isCapitalRequired(itemName) {
      if (!itemName) return false
      return itemName.includes('大写')
    },
    // 处理开标一览表内容输入，限制中文大写
    handleItemValueInput(row, index) {
      // 如果是总价字段，自动转换为大写并填入总价(大写)字段
      if (row.itemName === '总价' && row.itemValue) {
        // 查找总价(大写)字段
        const capitalPriceItem = this.openingSummaryList.find(item =>
          item.itemName === '总价(大写)' || item.itemName.includes('大写')
        )
        if (capitalPriceItem) {
          // 将数字转换为中文大写
          const capitalValue = this.numberToChineseCapital(row.itemValue)
          if (capitalValue) {
            this.$set(capitalPriceItem, 'itemValue', capitalValue)
          }
        }
      }
      if (!this.isCapitalRequired(row.itemName)) {
        // 如果不需要大写限制，直接返回
        return
      }
      const value = row.itemValue || ''
      // 中文大写数字正则表达式
      const chineseCapitalRegex = /^[零壹贰叁肆伍陆柒捌玖拾佰仟万亿元角分整]+$/
      if (!chineseCapitalRegex.test(value)) {
        // 只保留合法的中文大写字符
        const filteredValue = value.replace(/[^零壹贰叁肆伍陆柒捌玖拾佰仟万亿元角分整]/g, '')
        this.$set(this.openingSummaryList[index], 'itemValue', filteredValue)
        // 提示用户
        if (value !== filteredValue) {
          this.$message.warning('请输入中文大写数字')
        }
      }
    },
    // 数字转中文大写金额
    numberToChineseCapital(money) {
      // 处理空值和非数字
      if (!money || isNaN(parseFloat(money))) {
        return ''
      }

      const num = parseFloat(money)

      // 汉字的数字
      const cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
      // 基本单位
      const cnIntRadice = ['', '拾', '佰', '仟']
      // 对应整数部分扩展单位
      const cnIntUnits = ['', '万', '亿', '兆']
      // 对应小数部分单位
      const cnDecUnits = ['角', '分']
      // 最大处理的数字
      const maxNum = 9999999999999999.99

      if (num >= maxNum) {
        return '金额过大'
      }

      if (num === 0) {
        return cnNums[0]
      }

      // 转换为字符串
      let moneyStr = num.toFixed(2)
      let integerNum // 金额整数部分
      let decimalNum // 金额小数部分

      // 分离金额整数部分和小数部分
      const parts = moneyStr.split('.')
      integerNum = parts[0]
      decimalNum = parts.length > 1 ? parts[1] : ''

      // 整数部分处理
      let chineseStr = ''
      if (parseInt(integerNum, 10) > 0) {
        let zeroCount = 0
        const intLen = integerNum.length

        for (let i = 0; i < intLen; i++) {
          const n = integerNum.substr(i, 1)
          const p = intLen - i - 1
          const q = p / 4
          const m = p % 4

          if (n === '0') {
            zeroCount++
          } else {
            if (zeroCount > 0) {
              chineseStr += cnNums[0]
            }
            zeroCount = 0
            chineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
          }

          if (m === 0 && zeroCount < 4) {
            chineseStr += cnIntUnits[q]
          }
        }
      }

      // 小数部分处理
      if (decimalNum !== '' && decimalNum !== '00') {
        for (let i = 0; i < decimalNum.length; i++) {
          const n = decimalNum.substr(i, 1)
          if (n !== '0') {
            chineseStr += cnNums[parseInt(n)] + cnDecUnits[i]
          }
        }
      }
      if (chineseStr === '') {
        chineseStr = cnNums[0]
      }
      return chineseStr
    },

    handleEncryptClick() {
      this.encryptOpeningSummaryList()
    },

    getOpeningSummarySnapshot() {
      return JSON.stringify(Array.isArray(this.openingSummaryList) ? this.openingSummaryList : [])
    },

    hasOpeningSummaryChanges() {
      return this.getOpeningSummarySnapshot() !== (this.openingSummarySavedSnapshot || '[]')
    },

    async ensureSymKeyReady(options = {}) {
      const { showMessage = true } = options
      if (this.symKey) {
        return true
      }
      try {
        const keyRes = await getBidKeyInfo(this.projectInfo.sectionCode)
        if (keyRes.code === 200 && keyRes.data && keyRes.data.secretKey) {
          // 先保存密钥信息（包含加密后的secretKey）
          this.bidKeyInfo = keyRes.data
          // 解密secretKey获取明文对称密钥
          const plainKey = await this.decryptSecretKey(keyRes.data.secretKey)
          if (plainKey) {
            this.symKey = plainKey
            return true
          }
        }
      } catch (error) {
        console.error('获取已有对称密钥失败:', error)
      }

      try {
        await this.getSymKeySilent()
        if (this.symKey) {
          // 新生成的key，用CA公钥加密后存入bidKeyInfo.secretKey，保存时使用
          try {
            if (!this.asymForm.cert) {
              await this.exportExchangeCert(this.defaultCaCertId)
            }
            if (this.asymForm.cert) {
              const cipher = await this.xtxObject.SOF_PubKeyEncrypt(this.asymForm.cert, this.symKey)
              if (cipher) {
                this.bidKeyInfo = { secretKey: cipher }
              }
            }
          } catch (e) {
            console.error('新密钥加密失败，secretKey将为空:', e)
          }
          if (!this.bidKeyInfo || !this.bidKeyInfo.secretKey) {
            if (showMessage) {
              this.$message.warning('缺少加密密钥，无法继续保存或加密上传')
            }
            return false
          }
          return true
        }
      } catch (error) {
        console.error('生成对称密钥失败:', error)
      }

      if (showMessage) {
        this.$message.warning('请先获取对称密钥')
      }
      return false
    },

    async saveOpeningSummaryIfNeeded(options = {}) {
      const { force = false, showSuccess = true } = options
      if (!Array.isArray(this.openingSummaryList) || this.openingSummaryList.length === 0) {
        return false
      }
      const keyReady = await this.ensureSymKeyReady({ showMessage: true })
      if (!keyReady) {
        return false
      }
      if (!force && !this.hasOpeningSummaryChanges()) {
        return false
      }
      const plainText = JSON.stringify(this.openingSummaryList)
      const encryptMethod = 0x00000401
      const setResult = await this.xtxObject.SOF_SetEncryptMethod(encryptMethod)
      if (setResult !== 0) {
        this.$message.error('设置加密算法失败!')
        throw new Error('设置加密算法失败')
      }
      const cipherText = await this.xtxObject.SOF_SymEncryptData(this.symKey, plainText)
      if (!cipherText) {
        this.$message.error('开标一览表加密失败!')
        throw new Error('开标一览表加密失败')
      }
      const res = await this.addOpeningSummary(cipherText)
      if (res && res.code !== 200) {
        this.$message.error(res.msg || '开标一览表保存失败')
        throw new Error(res.msg || '开标一览表保存失败')
      }
      this.openingSummarySavedSnapshot = this.getOpeningSummarySnapshot()
      if (showSuccess) {
        this.$message.success('开标一览表保存成功')
      }
      return true
    },

    async handleOpeningSummarySave() {
      const keyReady = await this.ensureSymKeyReady({ showMessage: true })
      if (!keyReady) {
        return
      }
      await this.saveOpeningSummaryIfNeeded({ force: true, showSuccess: true })
      if (Array.isArray(this.pendingAttFiles) && this.pendingAttFiles.length > 0) {
        await this.encryptAndUploadAttFiles()
      }
    },

    async handleBidAttSave() {
      const keyReady = await this.ensureSymKeyReady({ showMessage: true })
      if (!keyReady) {
        return
      }
      await this.saveOpeningSummaryIfNeeded({ force: false, showSuccess: true })
      await this.encryptAndUploadAttFiles()
    },

    async handleBidMainSave() {
      const keyReady = await this.ensureSymKeyReady({ showMessage: true })
      if (!keyReady) {
        return
      }
      await this.saveOpeningSummaryIfNeeded({ force: false, showSuccess: true })
      if (Array.isArray(this.pendingAttFiles) && this.pendingAttFiles.length > 0) {
        await this.encryptAndUploadAttFiles()
      }
      await this.encryptAndUploadMain()
    },

    handleMenuSelect(key) {
      this.activeMenu = key
      if (key === '4-1') {
        this.getBidMain()
        this.loadInvitationCatalogue()
      }
    },

    handleCatalogueClick(data) {
      if (data && data.pageNum) {
        this.jumpBidPdf(data.pageNum)
      } else {
        this.$message.info('该目录未关联页码')
      }
    },

    async bindCataloguePage(item) {
      if (!item) return
      if (!this.currentBidPage) {
        this.$message.warning('无法获取当前页码')
        return
      }
      const res = await getBidCatalogue({
        id: item.strId,
        pageNum: this.currentBidPage,
        sectionCode: item.bidSectionCode || this.projectInfo.sectionCode
      })
      if (res.code === 200) {
        this.$message.success(`已关联到第${this.currentBidPage}页`)
        this.loadInvitationCatalogue()
      } else {
        this.$message.error(res.msg || '关联页码失败')
      }
    },

    async loadInvitationCatalogue() {
      try {
        const res = await getInvitationCatalogue(this.projectInfo.sectionCode)
        if (res.code === 200) {
          this.catalogueList = Array.isArray(res.data) ? res.data : []
        } else {
          this.$message.error(res.msg || '获取目录失败')
        }
      } catch (error) {
        console.error('获取目录失败:', error)
      }
    },

    onBidPdfLoaded() {
      this.currentMainPdfLoadedUrl = this.mainPdfDisplayUrl || ''
    },

    handleBidPdfError(error) {
      console.warn('投标正文 PDF 加载事件异常:', error)
      if (!this.mainPdfDisplayUrl) {
        return
      }
      if (this.currentMainPdfLoadedUrl && this.currentMainPdfLoadedUrl === this.mainPdfDisplayUrl) {
        return
      }
    },

    onBidPdfPageChanged(event) {
      try {
        this.currentBidPage = typeof event === 'number'
          ? event
          : (event && (event.pageNumber || event.page || event.currentPage)) || this.currentBidPage
      } catch (error) {
        console.error('PDF页码变化处理错误:', error)
      }
    },

    jumpBidPdf(page) {
      const viewer = this.$refs.bidPdfViewer
      if (viewer && typeof viewer.goToPage === 'function') {
        viewer.goToPage(page)
      } else {
        this.$message.warning('PDF预览尚未就绪')
      }
    },

    downloadBidMain() {
      if (!this.mainPdfDisplayUrl) {
        this.$message.warning('暂无可下载的投标正文')
        return
      }
      const link = document.createElement('a')
      link.href = this.mainPdfDisplayUrl
      link.download = '投标正文.pdf'
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    // 签章返回后恢复页面状态
    restorePageStateAfterSign() {
      const savedState = sessionStorage.getItem('makeBidDocumentState')
      if (savedState) {
        try {
          const state = JSON.parse(savedState)
          // 恢复CA状态
          if (state.caLoggedIn !== undefined) this.caLoggedIn = state.caLoggedIn
          if (state.caForm) this.caForm = state.caForm
          if (state.currentCaUserName) this.currentCaUserName = state.currentCaUserName
          if (state.certList) this.certList = state.certList
          if (state.symKey) this.symKey = state.symKey
          if (state.bidKeyInfo) this.bidKeyInfo = state.bidKeyInfo
          // 恢复开标一览表（暂存未保存的修改）
          if (state.openingSummaryList && state.openingSummaryList.length > 0) {
            this.openingSummaryList = state.openingSummaryList
          }
          // 恢复附件列表
          if (state.pendingAttFiles) this.pendingAttFiles = state.pendingAttFiles
          // 恢复当前菜单
          if (state.activeMenu) this.activeMenu = state.activeMenu

          sessionStorage.removeItem('makeBidDocumentState')
          console.log('签章返回后页面状态已恢复')
        } catch (e) {
          console.error('恢复页面状态失败:', e)
        }
      }
    },
    /******** ----------------ca相关---------------- ********/
    // 初始化证书列表（静默获取）
    async initCertList() {
      this.isLoadingCert = true
      try {
        await this.xtxObject.initWebSocket()
        await this.xtxObject.SOF_GetUserList()
        await this.$nextTick()
        const certList = this.caStore.state.XTXModel.ukeyList || []
        this.certList = Array.isArray(certList) ? certList : []
        if (this.certList.length > 0 && !this.caForm.certId) {
          this.caForm.certId = this.certList[0].certid
          this.currentCaUserName = this.certList[0].name

        }
        await this.checkCALoginStatus(false)
      } catch (e) {
        console.error('获取证书列表失败:', e)
      } finally {
        this.isLoadingCert = false
      }
    },
    getCurrentOperateCertId() {
      return this.caForm.certId || this.defaultCaCertId
    },
    handleCAUserChange(certId) {
      const currentUser = this.certList.find(item => item.certid === certId)
      this.currentCaUserName = currentUser?.name || ''
      // 如果已登录，根据选中用户更新当前显示
      if (this.caLoggedIn && currentUser) {
        this.currentCaUserName = currentUser.name || '已登录用户'
      }
    },

    async checkCALoginStatus(showMessage = true) {
      this.caStatusLoading = true
      try {
        await this.xtxObject.initWebSocket()
        const result = await this.xtxObject.SOF_IsLogin(this.defaultCaCertId)
        const loggedIn = result === true || result === 'true'
        this.caLoggedIn = loggedIn
        if (loggedIn) {
          // 刷新证书列表，从列表中识别当前用户
          await this.xtxObject.SOF_GetUserList()
          await this.$nextTick()
          const certList = this.caStore.state.XTXModel.ukeyList || []
          this.certList = Array.isArray(certList) ? certList : []
          if (this.certList.length > 0) {
            const currentUser = this.certList.find(item => item.certid === this.caForm.certId) || this.certList[0]
            this.caForm.certId = currentUser.certid
            this.currentCaUserName = currentUser.name || '已登录用户'
          }
          // 已登录则自动获取密钥并解密开标一览表
          await this.getBidKeyInfoAndDecrypt()
        } else {
          this.currentCaUserName = ''
        }
        if (showMessage) {
          this.$message[loggedIn ? 'success' : 'warning'](loggedIn ? 'CA 当前已登录' : 'CA 当前未登录')
        }
      } catch (error) {
        console.error('检查 CA 登录状态失败:', error)
        if (showMessage) {
          this.$message.error('检查 CA 登录状态失败')
        }
      } finally {
        this.caStatusLoading = false
      }
    },

    // CA登录
    async handleCALogin(targetCertId = this.caForm.certId) {
      const certId = this.defaultCaCertId
      this.caLoading = true
      try {
        await this.xtxObject.initWebSocket()
        const result = await this.xtxObject.SOF_Login(certId, '111111')
        if (result) {
          this.caLoggedIn = true
          await this.initCertList()
          if (this.certList.length > 0) {
            const matchedUser = this.certList.find(item => item.certid === targetCertId) || this.certList[0]
            this.caForm.certId = matchedUser.certid
            this.currentCaUserName = matchedUser.name || ''

          }
          this.$message.success('CA登录成功')
          // 登录成功后导出加密证书
          await this.exportExchangeCert(this.defaultCaCertId)
          // 登录成功后自动获取密钥并解密
          await this.getBidKeyInfoAndDecrypt()

        } else {
          this.$message.error('CA登录失败')
        }
      } catch (error) {
        console.error('CA登录错误:', error)
        this.$message.error('CA登录失败：' + (error.message || '未知错误'))
      } finally {
        this.caLoading = false
      }
    },
    //ca退出
    async handleCALogout(showMessage = true) {
      this.caLogoutLoading = true
      try {
        await this.xtxObject.initWebSocket()
        const result = await this.xtxObject.SOF_Logout(this.defaultCaCertId)
        const success = result === true || result === 'true' || result === 0 || result === '0' || result === 1 || result === '1'
        this.caLoggedIn = false
        this.currentCaUserName = ''
        this.asymForm.cert = ''
        if (showMessage) {
          this.$message[success ? 'success' : 'warning'](success ? 'CA 已退出登录' : 'CA 退出结果待确认')
        }
        this.caForm.certId ='';
        return success
      } catch (error) {
        console.error('CA退出错误:', error)
        if (showMessage) {
          this.$message.error('CA退出失败：' + (error.message || '未知错误'))
        }
        return false
      } finally {
        this.caLogoutLoading = false
      }
    },

    async handleCASwitch() {
      if (!this.caForm.certId) {
        this.$message.warning('请先选择要切换的 CA 用户')
        return
      }
      this.caSwitchLoading = true
      try {
        const targetCertId = this.caForm.certId
        await this.handleCALogout(false)
        this.symKey = ''
        this.bidKeyInfo = null
        this.currentCaUserName = ''
        await this.handleCALogin(targetCertId)
        this.$message.success('请使用新用户完成扫码登录')
        this.caForm.certId =''
      } catch (error) {
        console.error('切换 CA 失败:', error)
        this.$message.error('切换 CA 失败：' + (error.message || '未知错误'))
      } finally {
        this.caSwitchLoading = false
      }
    },

    // 导出加密证书（Exchange证书用于公钥加密）
    async exportExchangeCert(certId) {
      try {
        const result = await this.xtxObject.SOF_ExportExChangeUserCert(certId)
        if (result) {
          this.asymForm.cert = result
          console.log('导出加密证书成功')
        } else {
          this.$message.error('导出加密证书失败')
        }
      } catch (e) {
        console.error('导出加密证书错误:', e)
        this.$message.error('导出加密证书失败：' + (e.message || '未知错误'))
      }
    },
    //
    async finishBidMakeAndExportKey() {
      if (!this.symKey) {
        this.$message.warning('缺少对称密钥，无法导出开标保障密钥')
        return
      }
      if (!this.caLoggedIn) {
        this.$message.warning('请先完成CA登录')
        return
      }
      if (!this.asymForm.cert) {
        await this.exportExchangeCert(this.defaultCaCertId)
      }
      if (!this.asymForm.cert) {
        this.$message.error('导出加密证书失败，无法生成开标保障密钥')
        return
      }
      let cipher = ''
      try {
        cipher = await this.xtxObject.SOF_PubKeyEncrypt(this.asymForm.cert, this.symKey)
      } catch (error) {
        console.error('开标保障密钥公钥加密失败:', error)
        this.$message.error('开标保障密钥加密失败：' + (error.message || '未知错误'))
        return
      }
      if (!cipher) {
        this.$message.error('开标保障密钥加密失败')
        return
      }
      const res = await finishBidMake({
        secretKey: cipher,
        sectionCode: this.projectInfo.sectionCode
      })
      if (res.code === 200) {
        // 下载加密前的原始对称密钥（本地 symKey），而非接口返回的加密数据
        if (this.symKey) {
          const blob = new Blob([this.symKey], { type: 'text/plain;charset=utf-8' })
          const url = URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = '开标保障密钥.txt'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          URL.revokeObjectURL(url)
        }
      } else {
        this.$message.error(res.msg || '导出开标保障密钥失败')
      }
    },

    // 静默获取对称密钥
    async getSymKeySilent() {
      try {
        const encryptMethod = 0x00000401
        await this.xtxObject.SOF_SetEncryptMethod(encryptMethod)
        const key = await this.xtxObject.SOF_GenRandom(16)
        if (key) {
          this.symKey = key
        }
      } catch (e) {
        console.error('获取对称密钥失败:', e)
      }
    },

    // 加密开标一览表数据并打印
    async encryptOpeningSummaryList() {
      const keyReady = await this.ensureSymKeyReady({ showMessage: true })
      if (!keyReady) {
        return
      }

      const loading = this.$loading({ text: '正在加密上传...', spinner: 'el-icon-loading' })
      try {
        await this.saveOpeningSummaryIfNeeded({ force: false, showSuccess: false })
        console.log('开始加密上传附件...')
        await this.encryptAndUploadAttFiles()
        console.log('附件上传完成')
        console.log('开始加密上传正文...')
        await this.encryptAndUploadMain()
        console.log('正文上传完成')

        console.log('开始导出开标保障密钥...')
        await this.finishBidMakeAndExportKey()
        console.log('开标保障密钥导出完成')
        this.$message.success('所有文件加密上传成功')
        // setTimeout(() => {
        //   this.$router.go(-1)
        // }, 1000);
      } catch (error) {
        this.$message.error('加密失败：' + (error.message || '未知错误'));
      } finally {
        loading.close()
      }
    },

    // 加密并上传投标附件
    async encryptAndUploadAttFiles() {
      if (!Array.isArray(this.pendingAttFiles) || this.pendingAttFiles.length === 0) {
        return
      }
      const keyReady = await this.ensureSymKeyReady({ showMessage: false })
      if (!keyReady) {
        this.$message.warning('缺少对称密钥，无法加密上传附件')
        return
      }
      if (!this.bidKeyInfo || !this.bidKeyInfo.secretKey) {
        this.$message.warning('缺少加密密钥，无法上传附件')
        throw new Error('缺少加密密钥，无法上传附件')
      }
      const loading = this.$loading({ text: '正在加密上传附件...' })
      try {
        // 设置加密算法
        const encryptMethod = 0x00000401; // SM4_ECB
        const setResult = await this.xtxObject.SOF_SetEncryptMethod(encryptMethod);
        if (setResult !== 0) {
          this.$message.error('设置加密算法失败!');
          loading.close()
          return;
        }
        let successCount = 0
        let failCount = 0
        let processedCount = 0
        // 循环处理每个附件
        for (const file of this.pendingAttFiles) {
          if (!file || !file.raw) continue
          processedCount++
          try {
            // 1. 读取文件为 base64
            const base64 = await this.fileToBase64(file.raw)
            // 2. 使用对称密钥加密 base64
            const encryptedBase64 = await this.xtxObject.SOF_SymEncryptData(this.symKey, base64);
            if (!encryptedBase64 || encryptedBase64 === "") {
              console.error(`附件 ${file.name} 加密失败`)
              failCount++
              continue
            }
            // 3. 调用接口上传
            const res = await uploadBidAtt({
              sectionCode: this.projectInfo.sectionCode,
              fileBase64: encryptedBase64,
              fileName: file.name,
              size: file.size,
              secretKey: this.bidKeyInfo?.secretKey || ''
            })
            if (res.code === 200) {
              successCount++
            } else {
              console.error(`附件 ${file.name} 上传失败:`, res.msg)
              failCount++
            }
          } catch (e) {
            console.error(`附件 ${file.name} 处理失败:`, e)
            failCount++
          }
        }
        if (successCount > 0) {
          this.$message.success(`成功上传 ${successCount} 个附件`)
          // 清空待上传列表
          this.pendingAttFiles = []
          if (this.$refs.attUploader) {
            this.$refs.attUploader.uploadFiles = []
          }
          // 刷新已上传列表
          await this.loadBidAttList()
        }
        if (processedCount === 0) {
          return
        }
        if (Number(failCount) > 0) {
          this.$message.warning(`${failCount} 个附件上传失败`)
          throw new Error(`${failCount} 个附件上传失败`)
        }
      } catch (error) {
        console.error('附件加密上传错误:', error);
        this.$message.error('附件上传失败：' + (error.message || '未知错误'));
        throw error
      } finally {
        loading.close()
      }
    },
    // 加密并上传投标正文
    async encryptAndUploadMain() {
      // 检查是否有正文可上传（签章后的或未签章的本地文件）
      if (!this.signedMainBase64 && !this.pendingMainFile) {
        return
      }
      const keyReady = await this.ensureSymKeyReady({ showMessage: false })
      if (!keyReady) {
        this.$message.warning('缺少对称密钥，无法加密正文')
        return
      }
      if (!this.bidKeyInfo || !this.bidKeyInfo.secretKey) {
        this.$message.warning('缺少加密密钥，无法上传正文')
        throw new Error('缺少加密密钥，无法上传正文')
      }
      try {
        let base64 = ''
        let fileName = ''
        if (this.signedMainBase64) {
          // 使用签章后的 base64
          base64 = this.signedMainBase64
          fileName = this.pendingMainFile?.name || '投标正文.pdf'
        } else if (this.pendingMainFile?.raw) {
          // 未签章时，将本地文件转为 base64
          fileName = this.pendingMainFile.name
          base64 = await this.fileToBase64(this.pendingMainFile.raw)
        }
        if (!base64) {
          this.$message.warning('正文文件数据为空')
          return
        }
        // 设置加密算法
        const encryptMethod = 0x00000401 // SM4_ECB
        const setResult = await this.xtxObject.SOF_SetEncryptMethod(encryptMethod)
        if (setResult !== 0) {
          this.$message.error('设置加密算法失败!')
          return
        }
        // 加密正文 base64
        const encryptedBase64 = await this.xtxObject.SOF_SymEncryptData(this.symKey, base64)
        if (!encryptedBase64 || encryptedBase64 === "") {
          this.$message.error('正文加密失败!')
          return
        }
        // 上传正文
        const res = await uploadBidSign({
          sectionCode: this.projectInfo.sectionCode,
          fileBase64: encryptedBase64,
          fileName: fileName,
          secretKey: this.bidKeyInfo?.secretKey || ''
        })

        if (res.code === 200) {
          this.$message.success('投标正文上传成功')
          if (this.bidMainUrl && this.bidMainUrl.startsWith('blob:')) {
            URL.revokeObjectURL(this.bidMainUrl)
          }
          this.bidMainUrl = ''
          this.currentMainPdfLoadedUrl = ''
          // 清空本地正文数据
          this.signedMainBase64 = ''
          this.signedMainBlobUrl = ''
          this.pendingMainFile = null
          if (this.$refs.mainUploader) {
            this.$refs.mainUploader.clearFiles()
          }
          await this.getBidMain()
          await this.loadInvitationCatalogue()
        } else {
          this.$message.error(res.msg || '正文上传失败')
        }
      } catch (error) {
        console.error('正文加密上传错误:', error)
        this.$message.error('正文上传失败：' + (error.message || '未知错误'))
      }
    },
    // 获取投标正文
    async getBidMain() {
      try {
        const res = await getBidMain(this.projectInfo.sectionCode)
        console.log('getBidMain 接口返回:', res)
        if (res.code !== 200) {
          this.$message.error(res.msg || '获取投标正文失败')
          return
        }
        const data = res.data || {}
        console.log('data:', data, 'fileId:', data.fileId, 'encryptStatus:', data.encryptStatus)
        if (!data.fileId) {
          this.bidMainUrl = ''
          return
        }
        const downloadRes = await getFileDownloadList(data.fileId)
        if (downloadRes.code !== 200 || !downloadRes.data || !downloadRes.data.fileUrl) {
          this.$message.error('获取投标正文下载链接失败')
          return
        }
        if (Number(data.encryptStatus) === 1) {
          console.log('需要解密，当前 symKey:', this.symKey ? '有' : '无')
          if (!this.symKey) {
            const keyRes = await getBidKeyInfo(this.projectInfo.sectionCode)
            if (keyRes.code === 200 && keyRes.data && keyRes.data.secretKey) {
              // 解密secretKey
              const plainKey = await this.decryptSecretKey(keyRes.data.secretKey)
              if (plainKey) {
                this.symKey = plainKey
                this.bidKeyInfo = keyRes.data
              }
            }
          }
          if (!this.symKey) {
            this.$message.warning('无法解密投标正文,请检查登录状态')
            console.log('缺少对称密钥，退出')
            return
          }
          const encryptMethod = 0x00000401 // SM4_ECB
          const setResult = await this.xtxObject.SOF_SetEncryptMethod(encryptMethod)
          if (setResult !== 0) {
            this.$message.error('设置解密算法失败!')
            return
          }
          const encryptedResponse = await fetch(downloadRes.data.fileUrl)
          if (!encryptedResponse.ok) {
            this.$message.error('下载投标正文失败')
            return
          }
          let decryptedBase64 = ''
          try {
            const encryptedText = this.normalizeEncryptedText(await encryptedResponse.clone().text())
            console.log('尝试文本密文解密，长度:', encryptedText.length)
            if (encryptedText) {
              decryptedBase64 = await this.xtxObject.SOF_SymDecryptData(this.symKey, encryptedText)
              console.log('文本密文解密结果:', decryptedBase64 ? '成功' : '失败')
            }
          } catch (e) {
            console.warn('投标正文按文本密文解密失败，尝试二进制密文方式', e)
          }
          if (!decryptedBase64) {
            try {
              const encryptedBuffer = await encryptedResponse.arrayBuffer()
              const encryptedBase64 = this.arrayBufferToBase64(encryptedBuffer)
              console.log('尝试二进制密文解密，长度:', encryptedBase64.length)
              decryptedBase64 = await this.xtxObject.SOF_SymDecryptData(this.symKey, encryptedBase64)
              console.log('二进制密文解密结果:', decryptedBase64 ? '成功' : '失败')
            } catch (e) {
              console.warn('投标正文按二进制密文解密失败', e)
            }
          }
          if (!decryptedBase64) {
            this.$message.error('解密投标正文失败')
            console.log('两种解密方式都失败')
            return
          }
          console.log('解密成功，设置 bidMainUrl，解密结果长度:', decryptedBase64.length)
          console.log('解密结果前50字符:', decryptedBase64.substring(0, 50))
          console.log('是否是PDF格式:', decryptedBase64.startsWith('%PDF') || decryptedBase64.startsWith('JVBER'))
          const normalizedBase64 = this.normalizeBase64(decryptedBase64)
          console.log('标准化后base64长度:', normalizedBase64.length)
          const mainBlob = this.base64ToBlob(normalizedBase64)
          console.log('Blob类型:', mainBlob.type, 'Blob大小:', mainBlob.size)
          this.bidMainUrl = URL.createObjectURL(mainBlob)
          console.log('bidMainUrl 已设置:', this.bidMainUrl)
          console.log('mainPdfDisplayUrl 计算结果:', this.mainPdfDisplayUrl)
          return
        }
        const fileResponse = await fetch(downloadRes.data.fileUrl)
        if (!fileResponse.ok) {
          this.$message.error('下载投标正文失败')
          return
        }
        const arrayBuffer = await fileResponse.arrayBuffer()
        console.log('非加密文件，直接生成 Blob')
        const mainBlob = new Blob([arrayBuffer], { type: 'application/pdf' })
        this.bidMainUrl = URL.createObjectURL(mainBlob)
        console.log('非加密文件 bidMainUrl 已设置:', this.bidMainUrl)
      } catch (error) {
        console.error('获取投标正文失败:', error)
      }
    },
    // 加载已上传的投标附件列表
    async loadBidAttList() {
      try {
        const res = await getBidAttList(this.projectInfo.sectionCode)
        if (res.code === 200) {
          this.bidAttList = res.data || []
        }
      } catch (error) {
        console.error('获取已上传附件列表失败:', error)
      }
    },

    // 下载并解密附件
    async downloadAndDecryptAtt(att) {
      if (!att.fileId) {
        this.$message.warning('文件信息不完整')
        return
      }
      if (!this.symKey) {
        const keyRes = await getBidKeyInfo(this.projectInfo.sectionCode)
        if (keyRes.code === 200 && keyRes.data && keyRes.data.secretKey) {
          // 解密secretKey
          const plainKey = await this.decryptSecretKey(keyRes.data.secretKey)
          if (plainKey) {
            this.symKey = plainKey
            this.bidKeyInfo = keyRes.data
          }
        }
      }
      if (!this.symKey) {
        this.$message.warning('缺少对称密钥，无法解密附件')
        return
      }
      const loading = this.$loading({ text: '正在下载解密附件...' })
      try {
        // 1. 调用接口获取文件下载信息（包含 fileUrl）
        const res = await getFileDownloadList(att.fileId)
        if (res.code !== 200 || !res.data || !res.data.fileUrl) {
          this.$message.error('获取文件下载链接失败')
          loading.close()
          return
        }
        // 2. 从 fileUrl 下载文件内容
        const fileResponse = await fetch(res.data.fileUrl)
        if (!fileResponse.ok) {
          this.$message.error('下载文件失败')
          loading.close()
          return
        }
        // 4. 设置解密算法
        const encryptMethod = 0x00000401 // SM4_ECB
        const setResult = await this.xtxObject.SOF_SetEncryptMethod(encryptMethod)
        if (setResult !== 0) {
          this.$message.error('设置解密算法失败!')
          loading.close()
          return
        }
        // 5. 优先按文本密文解密，失败后回退到二进制密文方式
        let decryptedBase64 = ''
        try {
          const encryptedText = this.normalizeEncryptedText(await fileResponse.clone().text())
          if (encryptedText) {
            decryptedBase64 = await this.xtxObject.SOF_SymDecryptData(this.symKey, encryptedText)
          }
        } catch (e) {
          console.warn('附件按文本密文解密失败，尝试二进制密文方式', e)
        }

        if (!decryptedBase64) {
          try {
            const encryptedBuffer = await fileResponse.arrayBuffer()
            const encryptedBase64 = this.arrayBufferToBase64(encryptedBuffer)
            decryptedBase64 = await this.xtxObject.SOF_SymDecryptData(this.symKey, encryptedBase64)
          } catch (e) {
            console.warn('附件按二进制密文解密失败', e)
          }
        }
        if (!decryptedBase64) {
          this.$message.error('解密失败')
          loading.close()
          return
        }
        // 6. base64 转 Blob 并下载
        const blob = this.base64ToBlob(this.normalizeBase64(decryptedBase64))
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = att.fileName
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
        this.$message.success('附件下载成功')
      } catch (error) {
        console.error('下载解密附件失败:', error)
        this.$message.error('下载失败：' + (error.message || '未知错误'))
      } finally {
        loading.close()
      }
    },
    // 删除附件
    deleteAndDecryptAtt(row) {
      this.$confirm(`确定要删除附件 "${row.fileName}" 吗？`, '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await deleteBidAtt(row.fileId)
          if (res.code === 200) {
            this.$message.success('删除成功')
            // 刷新附件列表
            await this.loadBidAttList()
          } else {
            this.$message.error(res.msg || '删除失败')
          }
        } catch (error) {
          console.error('删除附件失败:', error)
          this.$message.error('删除失败：' + (error.message || '未知错误'))
        }
      }).catch(() => {
        // 用户取消删除
      })
    },

    // ArrayBuffer 转 base64
    arrayBufferToBase64(buffer) {
      const bytes = new Uint8Array(buffer)
      let binary = ''
      for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i])
      }
      return window.btoa(binary)
    },
    normalizeEncryptedText(text) {
      if (!text) return ''
      let normalized = String(text).trim()
      if ((normalized.startsWith('"') && normalized.endsWith('"')) || (normalized.startsWith("'") && normalized.endsWith("'"))) {
        normalized = normalized.slice(1, -1)
      }
      normalized = normalized.replace(/\r|\n/g, '')
      return normalized
    },
    normalizeBase64(base64) {
      if (!base64) return ''
      let normalized = String(base64).trim()
      if (normalized.includes(',')) {
        normalized = normalized.split(',').pop()
      }
      normalized = normalized.replace(/\r|\n/g, '').replace(/-/g, '+').replace(/_/g, '/')
      const padding = normalized.length % 4
      if (padding) {
        normalized += '='.repeat(4 - padding)
      }
      return normalized
    },

    // base64 转 Blob (默认 PDF 类型)
    base64ToBlob(base64, mimeType = 'application/pdf') {
      const safeBase64 = this.normalizeBase64(base64)
      try {
        const byteCharacters = atob(safeBase64)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        return new Blob([byteArray], { type: mimeType })
      } catch (error) {
        console.warn('base64ToBlob 按 base64 解码失败，回退为原始字节字符串处理', error)
        const rawText = String(base64 || '')
        const byteNumbers = new Array(rawText.length)
        for (let i = 0; i < rawText.length; i++) {
          byteNumbers[i] = rawText.charCodeAt(i) & 0xff
        }
        const byteArray = new Uint8Array(byteNumbers)
        return new Blob([byteArray], { type: mimeType })
      }
    },
  }
}
</script>

<style scoped>
.make-bid-document-page {
  min-height: 100%;
  padding: 24px;
  box-sizing: border-box;
  background: linear-gradient(180deg, #f4f8ff 0%, #eef3fb 100%);
}

.page-shell {
  display: flex;
  min-height: calc(100vh - 120px);
  border-radius: 24px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.88);
  border: 1px solid rgba(255, 255, 255, 0.7);
  box-shadow: 0 24px 60px rgba(31, 45, 61, 0.12);
  backdrop-filter: blur(14px);
}

.left-sidebar {
  width: 320px;
  padding: 28px 20px 24px;
  background: linear-gradient(180deg, #0f172a 0%, #172554 100%);
  color: #fff;
}

.sidebar-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 20px;
}

.sidebar-kicker {
  margin: 0 0 6px;
  font-size: 12px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.68);
}

.sidebar-title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.3;
}

.project-summary-card {
  margin-bottom: 20px;
  padding: 18px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.document-menu {
  border-right: none;
  background: transparent;
}

.document-menu /deep/ .el-submenu__title,
.document-menu /deep/ .el-menu-item {
  color: rgba(255, 255, 255, 0.78);
  border-radius: 14px;
  margin-bottom: 8px;
}

.document-menu /deep/ .el-submenu__title:hover,
.document-menu /deep/ .el-menu-item:hover,
.document-menu /deep/ .el-menu-item.is-active {
  color: #fff;
  background: rgba(255, 255, 255, 0.12);
}

.document-menu /deep/ .el-menu {
  background: transparent;
}

.right-content {
  flex: 1;
  padding: 28px;
  overflow-y: auto;
}

.hero-panel {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
  padding: 28px;
  border-radius: 24px;
  background: linear-gradient(135deg, #1d4ed8 0%, #3b82f6 55%, #93c5fd 100%);
  color: #fff;
  box-shadow: 0 20px 40px rgba(37, 99, 235, 0.22);
}

.hero-kicker {
  margin: 0 0 10px;
  font-size: 13px;
  letter-spacing: 1px;
  color: rgba(255, 255, 255, 0.82);
}

.hero-title {
  margin: 0 0 12px;
  font-size: 34px;
  line-height: 1.2;
}

.hero-desc {
  margin: 0;
  max-width: 720px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.9);
}

.hero-metrics {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
}

.metric-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 122px;
  padding: 18px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.16);
}

.metric-label,
.metric-extra {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.82);
}

.metric-value {
  font-size: 28px;
  font-weight: 700;
}

.toolbar-panel {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  padding: 22px 24px;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);
}

.panel-title {
  margin: 0 0 8px;
  font-size: 24px;
  color: #111827;
}

.panel-subtitle {
  margin: 0;
  color: #6b7280;
}

.toolbar-actions {
  display: flex;
  gap: 12px;
}

.content-panel {
  margin-bottom: 20px;
}

.single-template-card {
  padding: 36px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.08);
  border: 1px solid rgba(226, 232, 240, 0.9);
}

.menu-display-chip {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(59, 130, 246, 0.1);
  color: #2563eb;
  font-size: 12px;
  margin-bottom: 16px;
}

.menu-display-title {
  margin: 0 0 10px;
  font-size: 30px;
  color: #111827;
}

.menu-display-desc {
  margin: 0 0 26px;
  color: #6b7280;
  line-height: 1.8;
}

.pdf-preview-panel {
  min-height: 780px;
  border-radius: 24px;
  overflow: hidden;
  border: 1px solid #dbeafe;
  background: #f8fbff;
}

.pdf-viewer-container {
  height: 780px;
  display: flex;
  flex-direction: column;
}

.pdf-viewer-toolbar {
  display: flex;
  justify-content: flex-end;
  padding: 12px 16px;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
}

.pdf-viewer-container /deep/ .pdf-viewer {
  flex: 1;
}

.attachment-panel {
  border-radius: 24px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  background: #fff;
}

.attachment-table /deep/ .el-table__header-wrapper th {
  background: #f8fafc;
  color: #334155;
}

.opening-summary-panel {
  border-radius: 24px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  background: #fff;
}

.opening-summary-table /deep/ .el-table__header-wrapper th {
  background: #f8fafc;
  color: #334155;
}

.opening-summary-table .empty-value {
  color: #9ca3af;
  font-style: italic;
}

.card-header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}

.content-title {
  margin: 0 0 20px;
  font-size: 20px;
  color: #111827;
  font-weight: 600;
}

.content-body {
  margin-bottom: 20px;
}


.file-link {
  color: #2563eb;
  text-decoration: none;
}

.file-link:hover {
  text-decoration: underline;
}

.bid-att-panel,
.bid-main-panel .bid-sign-panel,
.encrypt-upload-panel {
  padding: 20px 0;
}

/* 投标正文预览区域 */
.main-preview-section {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: calc(100vh - 240px);
  overflow: hidden;
}

.preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e5e7eb;
}

.preview-header .section-title {
  margin: 0;
}

.preview-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.panel-header-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.panel-header-actions .content-title,
.panel-header-actions .section-title {
  margin: 0;
}

.main-pdf-viewer {
  flex: 1;
  min-height: 600px;
  display: flex;
  gap: 16px;
  min-height: 0;
  overflow: hidden;
}

.pdf-chapters {
  width: 280px;
  min-width: 280px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
  padding: 12px;
  overflow: auto;
}

.chapter-title {
  font-size: 14px;
  font-weight: 600;
  color: #334155;
  margin-bottom: 12px;
}

.catalogue-tree {
  max-height: 560px;
  overflow: auto;
}

.custom-tree-node {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding-right: 8px;
}

.catalogue-node-title {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.catalogue-node-tag {
  flex-shrink: 0;
}

.catalogue-node-action {
  flex-shrink: 0;
}

.pdf-viewer-panel {
  flex: 1;
  min-height: 600px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  background: #fff;
  display: flex;
  flex-direction: column;
}

.pdf-viewer-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.pdf-viewer-scroll /deep/ .pdf-viewer {
  min-height: 100%;
}

.no-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 400px;
  color: #94a3b8;
}

.no-preview i {
  font-size: 48px;
  margin-bottom: 16px;
}

.upload-empty-state {
  padding: 40px 0;
}

.encrypt-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  margin: 8px 12px;
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.85);
  cursor: pointer;
  font-size: 14px;
  transition: background 0.2s;
}

.encrypt-btn:hover {
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
}

.encrypt-btn i {
  font-size: 16px;
}

.encrypt-notice {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  padding: 40px;
  text-align: center;
}

.encrypt-notice i {
  font-size: 64px;
  color: #3b82f6;
  margin-bottom: 24px;
}

.encrypt-notice h3 {
  margin: 0 0 12px;
  font-size: 24px;
  color: #1e293b;
}

.encrypt-notice p {
  margin: 0 0 24px;
  color: #64748b;
}

/* 隐藏 el-upload 默认文件列表 */
.hide-file-list /deep/ .el-upload-list {
  display: none;
}

.ca-status-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.ca-status-title {
  margin: 4px 0 0;
  font-size: 16px;
  color: white;
}

.ca-status-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 10px;
}

.ca-status-row span {
  font-size: 12px;
  color: white;
}

.ca-status-row strong {
  font-size: 13px;
  color: white;
  word-break: break-all;
}

.ca-user-select {
  width: 100%;
  margin: 8px 0 12px;
}

.ca-action-group {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.ca-action-group .el-button {
  flex: 1;
}

.upload-section {
  margin-bottom: 24px;
}

.section-title {
  margin: 0 0 16px;
  font-size: 16px;
  color: #374151;
  font-weight: 500;
}

.att-uploader,
.main-uploader {
  padding: 20px;
  background: #f9fafb;
  border-radius: 12px;
  border: 2px dashed #d1d5db;
}

.existing-files,
.existing-main {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
}

.main-file-info {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #f3f4f6;
  border-radius: 8px;
  color: #2563eb;
}

.main-file-info i {
  font-size: 18px;
}

.bid-att-table /deep/ .el-table__header-wrapper th,
.bid-sign-table /deep/ .el-table__header-wrapper th {
  background: #f8fafc;
  color: #334155;
}

.pending-sign-table /deep/ .el-table__header-wrapper th {
  background: #f1f5f9;
  color: #475569;
}

/* 待上传文件列表 */
.pending-files {
  margin-bottom: 24px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}

.pending-att-table /deep/ .el-table__header-wrapper th {
  background: #f1f5f9;
  color: #475569;
}

.file-name-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.file-name-cell i {
  font-size: 18px;
  color: #64748b;
}

.danger-text {
  color: #ef4444;
}

/* 待上传正文卡片 */
.pending-main-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.file-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.file-info i {
  font-size: 24px;
  color: #3b82f6;
}

.file-name {
  font-weight: 500;
  color: #1e293b;
}

.file-size {
  color: #64748b;
  font-size: 13px;
}

.file-actions {
  display: flex;
  gap: 8px;
}

/* 预览弹窗 */
.preview-container {
  min-height: 400px;
  max-height: 70vh;
}

.preview-frame {
  width: 100%;
  height: 70vh;
  border: none;
}

.preview-image {
  max-width: 100%;
  max-height: 70vh;
  display: block;
  margin: 0 auto;
}

.preview-not-supported {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #64748b;
}

.preview-not-supported i {
  font-size: 48px;
  margin-bottom: 16px;
  color: #94a3b8;
}

.preview-not-supported p {
  margin-bottom: 20px;
}

.download-link {
  text-decoration: none;
}

.template-placeholder {
  display: flex;
  align-items: center;
  gap: 20px;
  min-height: 240px;
  padding: 28px;
  border-radius: 24px;
  background: linear-gradient(135deg, #eff6ff 0%, #f8fafc 100%);
  border: 1px dashed #93c5fd;
}

.placeholder-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 20px;
  background: linear-gradient(135deg, #dbeafe 0%, #eff6ff 100%);
  color: #2563eb;
  font-size: 30px;
}

.placeholder-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.placeholder-text strong {
  font-size: 22px;
  color: #111827;
}

.placeholder-text span {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.9;
}

@media (max-width: 1280px) {
  .hero-panel {
    grid-template-columns: 1fr;
  }

  .hero-metrics {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 960px) {
  .page-shell {
    flex-direction: column;
  }

  .left-sidebar {
    width: 100%;
  }

  .toolbar-panel {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .toolbar-actions {
    width: 100%;
    flex-wrap: wrap;
  }
}
</style>
